export var usePagination = function (setPage, setLimit, callUsers) {
    var onChangePage = function (page) {
        setPage(page);
        callUsers(true);
    };
    var onChangeLimit = function (limit) {
        setLimit(limit);
        callUsers(true);
    };
    return { onChangePage: onChangePage, onChangeLimit: onChangeLimit };
};
